export const getCurrentUser = () => {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return {};
    return JSON.parse(raw) || {};
  } catch {
    return {};
  }
};

export const getAuthToken = () => localStorage.getItem('token') || '';
